import { LoadingOutlined } from '@ant-design/icons';
import { Input, InputProps } from 'antd';
import clx from 'classnames';
import { useFormItemAccessibility } from '../../item/useFormItemAccessibility';

/**
 * Elemento grafico che ha gli stili di un Input.
 */
export interface StaticInputProps extends Omit<InputProps, 'name' | 'value'> {
  value: string | number | undefined;
  removeBorder?: boolean;
  loading?: boolean;
}

export function StaticInput(props: StaticInputProps) {
  const { className, children, size, removeBorder, loading, ...inputProps } =
    props;

  const accessibility = useFormItemAccessibility();

  return (
    <Input
      id={accessibility.attributes.id}
      variant={removeBorder ? 'borderless' : undefined}
      suffix={<span aria-hidden="true" />} // See https://ant.design/components/input#why-input-lose-focus-when-change-prefixsuffixshowcount
      size={size ?? 'large'}
      readOnly
      {...inputProps}
      className={clx(className, {
        'remove-border': removeBorder,
      })}
      prefix={loading ? <LoadingOutlined /> : children}
    />
  );
}
